import { Typography } from '@mui/material';
import React, { type MouseEvent } from 'react';
import Confirm from '../../../../../../components/Confirm';
import { useI18n } from '../../../../../../i18n/I18n';

type GridSettingsConfirmationsProps = {
    confirmAutosizeOpen: boolean;
    customRemovalPending: boolean;
    pendingSortFieldRemoval: boolean;
    onConfirmAutosize: (event: MouseEvent<HTMLButtonElement>) => void;
    onCancelAutosize: (event: MouseEvent<HTMLButtonElement>) => void;
    onConfirmCustomRemoval: (event: MouseEvent<HTMLButtonElement>) => void;
    onCancelCustomRemoval: (event: MouseEvent<HTMLButtonElement>) => void;
    onConfirmSortFieldRemoval: (event: MouseEvent<HTMLButtonElement>) => void;
    onCancelSortFieldRemoval: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function GridSettingsConfirmations({
    confirmAutosizeOpen,
    customRemovalPending,
    pendingSortFieldRemoval,
    onConfirmAutosize,
    onCancelAutosize,
    onConfirmCustomRemoval,
    onCancelCustomRemoval,
    onConfirmSortFieldRemoval,
    onCancelSortFieldRemoval
}: GridSettingsConfirmationsProps) {
    const t = useI18n();

    return (
        <>
            <Confirm
                open={confirmAutosizeOpen}
                title={t('grid.settings.autosize.confirm.title')}
                okLabelI18n="common.confirm"
                cancelLabelI18n="dialog.cancel"
                body={<Typography>{t('grid.settings.autosize.confirm.message')}</Typography>}
                onConfirm={onConfirmAutosize}
                onCancel={onCancelAutosize}
            />
            {customRemovalPending && (
                <Confirm
                    open
                    title={t('common.confirm.change')}
                    body={<Typography>{t('report.groupBy.change.confirmation.body')}</Typography>}
                    okLabelI18n="common.confirm"
                    onConfirm={onConfirmCustomRemoval}
                    onCancel={onCancelCustomRemoval}
                    isOkButtonContained
                />
            )}
            {pendingSortFieldRemoval && (
                <Confirm
                    open
                    title={t('report.groupBy.rankOrder.confirmation.title')}
                    body={<Typography>{t('report.groupBy.rankOrder.confirmation.body')}</Typography>}
                    okLabelI18n="common.confirm"
                    onConfirm={onConfirmSortFieldRemoval}
                    onCancel={onCancelSortFieldRemoval}
                    isOkButtonContained
                />
            )}
        </>
    );
}
